import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

//import theme from '@ecp/common/src/style/theme/default';
import { FlexBox, FlexBoxCenter } from '@ecp/common/src/layouts/flex/styled';
import RadioGroup from '@ecp/common/src/components/radio/RadioGroup';
import { Radio } from '@ecp/common/src/components/radio/Radio';
import { radioClassNames } from '@ecp/common/src/components/unstyled/input/RadioUnstyled';

export const defaultPeriods = [
  { name: '일주일', value: '1-weeks' },
  { name: '1개월', value: '1-months' },
  { name: '3개월', value: '3-months' },
  { name: '6개월', value: '6-months' },
  { name: '12개월', value: '12-months' },
];

const PeriodGroup = ({
  periods,
  onClick,
  rootComponent: RootComponent,
  periodItemButton: PeriodItemButton,
  ...props
}) => (
  <FlexBox width="100%" justify-content="flex-start">
    <RadioGroup name="periodGroup" rootComponent={RootComponent} {...props}>
      {periods.map(({ name, value }) => (
        <Radio key={name} hideControl value={value} onClick={onClick}>
          <PeriodItemButton>{name}</PeriodItemButton>
        </Radio>
      ))}
    </RadioGroup>
  </FlexBox>
);

PeriodGroup.propTypes = {
  periods: PropTypes.array,
  onClick: PropTypes.func,
  rootComponent: PropTypes.oneOfType([PropTypes.elementType, PropTypes.element, PropTypes.node]),
  periodItemButton: PropTypes.oneOfType([PropTypes.elementType, PropTypes.element, PropTypes.node]),
};

const Wrapper = styled(FlexBox)`
  height: 30px;
  width: fit-content;
  gap: 10px;
`;

const PeriodItemWrapper = styled(FlexBoxCenter)`
  width: fit-content;
  font-weight: 300;
  font-size: ${(props) => props.theme.font.size.small};
  line-height: 21px;
  padding: 4.5px 12px;
  cursor: pointer;

  background-color: ${(props) => props.theme.color.background.white};
  border-radius: 30px;

  color: ${(props) => props.theme.color.text.sub};
  border: 1px solid ${(props) => props.theme.color.line.background};

  &.${radioClassNames.checked} {
    color: ${(props) => props.theme.color.text.basic};
    border: 1px solid ${(props) => props.theme.color.line.emphasis};
  }
`;

PeriodGroup.defaultProps = {
  periods: defaultPeriods,
  periodItemButton: PeriodItemWrapper,
  rootComponent: Wrapper,
  onClick: () => {},
};

export default PeriodGroup;
